/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, OutlinedInput } from '@material-ui/core';
import images from 'assets/images';

export interface ISelectInputOption {
    title: string;
    value: any;
}

const FormikSelectInput = ({ field: { ...fields }, form: { touched, errors }, ...props }): React.ReactNode => {
    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth + 3);
    }, []);
    const { id, hasFirstOption, secondaryClass = '', ...rest } = props;
    const error = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));
    return (
        <FormControl
            className={`custom-select ${secondaryClass}`}
            error={error}
            variant={props.variant}
            id={props.inputprops?.id}
            fullWidth={props.fullWidth}
        >
            <InputLabel shrink ref={inputLabel}>
                {props.label}
            </InputLabel>
            <Select
                {...fields}
                {...rest}
                id={id}
                displayEmpty
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                }}
                input={<OutlinedInput notched labelWidth={labelWidth} />}
                IconComponent={(props) => (
                    <em {...props} className={`${props.className}`}>
                        <img src={images.downArrow} alt="View More" />
                    </em>
                )}
            >
                {hasFirstOption && <MenuItem value={typeof fields.value === 'string' ? '' : 0}>-- Select --</MenuItem>}
                {props.options &&
                    props.options.map((option: ISelectInputOption) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.title}
                        </MenuItem>
                    ))}
            </Select>
            {error && <FormHelperText error>{error && errors[fields.name]}</FormHelperText>}
        </FormControl>
    );
};
export default FormikSelectInput;
